/**
 * WordPress REST API client
 */

let restUrl = '/wp-json/greven/v1';
let nonce = '';

/**
 * Initialize API client with base URL and nonce
 *
 * @param {string} baseUrl REST API base URL
 * @param {string} apiNonce WordPress nonce for authenticated requests
 */
export function initApi( baseUrl, apiNonce ) {
	restUrl = baseUrl || restUrl;
	nonce = apiNonce || nonce;
}

/**
 * Get REST API base URL
 */
export function getRestUrl() {
	return restUrl;
}

/**
 * Make API request
 *
 * @param {string} endpoint API endpoint
 * @param {object} options Fetch options
 * @return {Promise<object>} Response data
 */
async function request( endpoint, options = {} ) {
	const url = `${ restUrl }${ endpoint }`;
	
	const defaultOptions = {
		headers: {
			'Content-Type': 'application/json',
		},
	};

	// Add nonce if available
	if ( nonce ) {
		defaultOptions.headers[ 'X-WP-Nonce' ] = nonce;
	}

	const mergedOptions = {
		...defaultOptions,
		...options,
		headers: {
			...defaultOptions.headers,
			...( options.headers || {} ),
		},
	};

    try {
        const response = await fetch( url, mergedOptions );
        const data = await response.json();
        // Always return response body; callers can inspect shape or HTTP status
        return { ...data, _httpStatus: response.status, _ok: response.ok };
    } catch ( error ) {
        console.error( 'API request failed:', error );
        throw error;
    }
}

/**
 * Submit form data
 *
 * @param {object} data Form data
 * @return {Promise<object>} Response
 */
export async function submit( data ) {
	return request( '/car-form/submit', {
		method: 'POST',
		body: JSON.stringify( data ),
	} );
}

/**
 * Calculate pricing/terms
 *
 * @param {object} params Calculation parameters
 * @return {Promise<object>} Response
 */
export async function calculate( params ) {
	const queryString = new URLSearchParams( params ).toString();
	return request( `/car-form/calculate?${ queryString }` );
}

/**
 * Get car data
 *
 * @param {number} carId Car ID
 * @return {Promise<object>} Response
 */
export async function getCar( carId ) {
	return request( `/car-form/car/${ carId }` );
}

/**
 * Get aanbod-new vehicle data by ULID.
 *
 * @param {string} vehicleUlid Vehicle ULID.
 * @return {Promise<object>} Response
 */
export async function getAanbodNewVehicle( vehicleUlid ) {
	return request( `/car-form/aanbod-new-vehicle/${ vehicleUlid }` );
}

/**
 * Default export with all methods
 */
export const wordpressApi = {
	initApi,
	getRestUrl,
	submit,
	calculate,
	getCar,
	getAanbodNewVehicle,
};

